import AudioFileIcon from '@mui/icons-material/AudioFile';
import ArticleIcon from '@mui/icons-material/Article';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import Box from '@mui/material/Box';
import type { SvgIconComponent } from '@mui/icons-material';

import { getFileKind } from '../FilesConsultation/utils/get-file-kind.util';
import type { FileKind } from '../FilesConsultation/utils/get-file-kind.util';

const ICON_BY_KIND: Readonly<Record<FileKind, SvgIconComponent>> = {
  archive: FolderZipIcon,
  audio: AudioFileIcon,
  document: ArticleIcon,
  image: ImageIcon,
  other: InsertDriveFileIcon,
  pdf: PictureAsPdfIcon,
  spreadsheet: TableChartIcon,
  video: VideoFileIcon,
};

interface Props {
  readonly mimeType: string;
}

export const FileTypeIcon = ({ mimeType }: Readonly<Props>) => {
  const Icon = ICON_BY_KIND[getFileKind(mimeType)];

  return (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: 'action.hover',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Icon color="disabled" sx={{ fontSize: '2.5rem' }} />
    </Box>
  );
};
